import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import styles from './TextareaSizesLikeDiv.module.scss';

export type TextareaSizesLikeDivProps = React.DetailedHTMLProps<
React.TextareaHTMLAttributes<HTMLTextAreaElement>,
HTMLTextAreaElement
>;

export const TextareaSizesLikeDiv: React.FC<TextareaSizesLikeDivProps> = (
	props
) => {
	// most of this machinery is here to get around how browsers don't want textarea to act like a div
	const ref = useRef<HTMLTextAreaElement>( null );
	useEffect( () => {
		/* This'll wait for a short period for the ref to get mounted, and trigger a false keyup event,
		which is what we need to auto-grow the textarea so it acts like a div */
		const initialLoad = ( counter = 0, delay = 50 ) =>
			setTimeout( () => {
				if ( ref.current ) {
					const event = new KeyboardEvent( 'keyup', {
						bubbles: true,
						cancelable: true,
						charCode: 0,
						keyCode: 0,
						key: ' ',
						shiftKey: false,
						altKey: false,
						ctrlKey: false,
						metaKey: false,
						repeat: false,
						location: KeyboardEvent.DOM_KEY_LOCATION_STANDARD,
					} );
					ref.current.dispatchEvent( event );
				} else if ( counter < 10 ) {
					initialLoad( counter + 1 );
				}
			}, delay );
		initialLoad( 0, 0 );
	}, [] );
	return (
		<textarea
			{ ...props }
			ref={ ref }
			className={ classNames( props.className, styles.container ) }
			onKeyUp={ ( e ) => {
				e.currentTarget.style.height = '0px';
				e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
			} }
		/>
	);
};
